import React from "react"
import SelectButton from "../../../../components/atoms/SelectButton.atom"
import {
  CLIENT_HISTORY_REPORT_TABS,
  CLIENT_HISTORY_REPORT_TABS_VALUES,
} from "../../../../consts/modules/clients.consts"
import { useSearchParams } from "react-router-dom"

import ClientTeamMembers from "./ClientTeamMembers.controller"
import ClientTeams from "./ClientTeams.controller"
import ClientSprints from "./ClientSprints/ClientSprints.controller"

const ClientHistory = ({ selectedPeriod }) => {
  const [searchParams, setSearchParams] = useSearchParams()
  const currentTab =
    searchParams.get("tab") || CLIENT_HISTORY_REPORT_TABS_VALUES.sprints

  const handleTabChange = (e) => {
    if (!e.value) return
    setSearchParams({ tab: e.value })
  }

  const renderCurrentTab = () => {
    switch (currentTab) {
      case CLIENT_HISTORY_REPORT_TABS_VALUES.sprints:
        return <ClientSprints selectedPeriod={selectedPeriod} />
      case CLIENT_HISTORY_REPORT_TABS_VALUES.desarrolladores:
        return <ClientTeamMembers selectedPeriod={selectedPeriod} />
      case CLIENT_HISTORY_REPORT_TABS_VALUES.equipos:
        return <ClientTeams selectedPeriod={selectedPeriod} />
      default:
        return <ClientSprints selectedPeriod={selectedPeriod} />
    }
  }
  return (
    <>
      <SelectButton
        options={CLIENT_HISTORY_REPORT_TABS}
        className="client-history-report-tabs-container"
        value={currentTab}
        onChange={handleTabChange}
      />
      {renderCurrentTab()}
    </>
  )
}

export default ClientHistory
